export default {"src":"/_next/static/media/wallet.c33541ad.svg","height":24,"width":24};